var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextAnime1"},_vm._l((_vm.text),function(t,index){return _c('span',{key:index,staticClass:"item",style:({animationDelay: index*50+'ms'}),domProps:{"textContent":_vm._s(t)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }